import { Outlet } from 'react-router-dom';
import Header from './header';

function Main() {
  return (
    <div>
      <header>
        <Header />
      </header>
      <main className="mt-4 mb-6 sm:mt-12 sm:mb-12 flex items-center justify-center">
        <Outlet />
      </main>
    </div>
  );
}

export default Main;
